import React, { useEffect, useState } from "react";
import api from "@/lib/api";

function fmtVal(v, unit) {
  if (v === null || v === undefined) return "—";
  if (unit === "%") return `${Number(v).toLocaleString("it-IT", { maximumFractionDigits: 1 })}%`;
  if (unit === "gg") return `${Number(v).toLocaleString("it-IT", { maximumFractionDigits: 0 })} gg`;
  if (unit === "€") return `€ ${Number(v).toLocaleString("it-IT", { maximumFractionDigits: 0 })}`;
  return Number(v).toLocaleString("it-IT", { maximumFractionDigits: 2 });
}

export default function SectorBenchmarks({ slug, compact = false }) {
  const [data, setData] = useState(null);
  useEffect(() => {
    if (!slug) return;
    api.get(`/public/sector-benchmarks/${slug}`).then(r => setData(r.data)).catch(() => setData({ benchmarks: [] }));
  }, [slug]);
  if (!data) return <div className="ic-card p-6 text-sm text-[#7A7788]">Caricamento benchmark…</div>;
  const items = (data.benchmarks || []).slice(0, compact ? 3 : 7);
  const year = items.find(b => b.available)?.reference_year;
  return (
    <div className="ic-card p-6" data-testid={`sector-benchmarks-${slug}`}>
      <p className="text-xs uppercase tracking-widest text-[#7A7788] mb-4">
        Benchmark di settore{year ? ` · Fonte BACH ${year}` : ""}
      </p>
      <div className="space-y-4">
        {items.map(b => (
          <div key={b.kpi_code} className="flex justify-between items-start gap-3 border-b border-[#F4F4F7] pb-3 last:border-0" data-testid={`benchmark-${b.kpi_code}`}>
            <p className="text-sm font-semibold">{b.label}</p>
            {b.available ? (
              <div className="text-right">
                <p className="text-lg font-bold text-[#5424D5]">{fmtVal(b.median, b.unit)}</p>
                {b.p25 != null && b.p75 != null && (
                  <p className="text-xs text-[#7A7788]">P25–P75: {fmtVal(b.p25, b.unit)} – {fmtVal(b.p75, b.unit)}</p>
                )}
              </div>
            ) : (
              <p className="text-xs text-[#7A7788] text-right">Benchmark non disponibile<br />per questo indicatore</p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
